var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('list',{ref:"list"},[(_vm.$permission.canWrite())?_c('template',{slot:"toolbar-right"},[_c('el-button',{attrs:{"size":"mini","type":"success","plain":""},on:{"click":_vm.onExport}},[_vm._v("导出")])],1):_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }